'use client';

import Grid from '@mui/material/Grid';
import type { Hit } from 'instantsearch.js';
import { AnalyticsPageNames } from '@/analytics/Page.types';
import ListingCard from '@/components/ListingCard';
import { BuyerListingFavorite } from '@/legacy/favorites/FavoritesViewModel';
import { isNewListing, isTrendingListing } from '@/lib/algolia/helpers';
import { ListingHit } from '@/types/ListingHit';
import { ListingHomePageRecommendation } from './types';

type Props = {
  favorites?: BuyerListingFavorite[];
  items: Hit<ListingHit>[];
  listingRecommendations?: ListingHomePageRecommendation[];
  section: string;
  isStockXSectionEnabled: boolean;
};

export const ListingCardHits = ({
  favorites,
  items,
  listingRecommendations = [],
  section,
  isStockXSectionEnabled,
}: Props) => {
  return items.map((hit) => (
    <Grid size={{ mobile: 2, desktop: 3, smallTablet: 4 }} key={hit.objectID}>
      <ListingCard
        analyticsInfo={{
          new: isNewListing(hit),
          trending: isTrendingListing(hit),
          context: { page: AnalyticsPageNames.BUYER_HOME, section },
        }}
        hit={hit}
        isFavorite={!!favorites?.some((f) => f.listingId === Number(hit.objectID))}
        isFirstPage
        listingRecommendation={listingRecommendations.find(
          (r) => r.listingId === Number(hit.objectID),
        )}
        isStockXSectionEnabled={isStockXSectionEnabled}
      />
    </Grid>
  ));
};
